// removed by extract-text-webpack-plugin
module.exports = {"root":"_2R5KzxRsalrL48oR_Jzccp"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true,"publicPath":"/"}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-41b1d238","scoped":false,"hasInlineConfig":false}!./~/gotu-vue-dycolor/dist/lib/dycolor-loader.js!./~/sass-loader/lib/loader.js?{"sourceMap":true}!./src/gotu-vue-common/src/components/timeline/events/sms-log/SmsLog.scss
// module id = 964
// module chunks = 1